export const siteConfig = {
	title: "Stone",
	fullTitle: "Write In Stone",
	tagLine: "Research is valuable. Make it visible.",
	url: "https://www.writeinstone.com",
}
